/**
 * LISTA NUMERADA EN LA CONVERSACIÓN (`sk-proselist`, 2026-10-30, decisión
 * de Martí): cuando el método enumera pasos u opciones (tres o más; nunca
 * para cifras), el asesor puede escribir UNA lista «1. …». Se pinta con la
 * pieza del sistema — número en su columna, a plomo con la prosa, y el
 * texto que salta de línea alineado con el texto, no bajo el número —, sin
 * viñetas del navegador. Se lee como prosa: sin caja ni acciones.
 *
 * La numeración la pone la pieza (1, 2, 3…), no el texto del modelo: si
 * se salta un número o repite el «1.», se ve bien igualmente.
 */
import { cx } from "../cx";
import { Trozos } from "./Trozos";

export function ProseList({ items, className }: { items: ReadonlyArray<string>; className?: string | undefined }) {
  return (
    // role=list explícito: con `list-style:none`, Safari/VoiceOver deja de anunciarla como lista
    <ol role="list" className={cx("sk-proselist", className)}>
      {/* UN hijo por ítem: el li es una retícula (número · texto) y los trozos con énfasis
          (<span>, <b>, <i>) caerían cada uno en su celda */}
      {items.map((t, i) => <li key={i}><span><Trozos texto={t} /></span></li>)}
    </ol>
  );
}
